import { Link } from 'react-router-dom'
import SignInContent from '../../components/admin/SignInContent'
import styles from '../../styles/admin/SignInPage.module.scss'

const SignIn = () => {
  return (
    <div className={styles.pageWrapper}>

      {/* ── Layer 0: 배경 블롭 ── */}
      <img src="/assets/login/background-5.svg" alt="" className={styles.topBg} />
      <img src="/assets/login/background-7.svg" alt="" className={styles.footerBg} />
      <img src="/assets/login/background-6.svg" alt="" className={styles.bottomRightBg} />

      {/* ── Layer 1: 좌하단 클로버 ── */}
      <img src="/assets/login/background-8.svg" alt="" className={styles.bottomLeftBg} />

      {/* ── Layer 1: 산포 데코 (시안 위치 기준) ── */}
      {/* deco-1 연파랑 — 좌카드 왼쪽 */}
      <img src="/assets/login/deco-1.svg" alt="" className={styles.deco1} />
      {/* deco-2 보라 — 우측 상단 */}
      <img src="/assets/login/deco-2.svg" alt="" className={styles.deco2} />
      {/* deco-3 연초록 — 우카드 오른쪽 */}
      <img src="/assets/login/deco-3.svg" alt="" className={styles.deco3} />
      {/* deco-4 틸 — 두 카드 사이 상단 */}
      <img src="/assets/login/deco-4.svg" alt="" className={styles.deco4} />
      {/* deco-5 흰색 — 좌카드 상단 왼쪽 */}
      <img src="/assets/login/deco-5.svg" alt="" className={styles.deco5} />
      {/* deco-6 노랑 — 우카드 상단 */}
      <img src="/assets/login/deco-6.svg" alt="" className={styles.deco6} />

      {/* ── Header ── */}
      <header className={styles.pageHeader}>
        <Link to="/" className={styles.logoLink}>
          <img src="/assets/white-logo.svg" alt="Solution M" className={styles.logoImg} />
        </Link>
      </header>

      {/* ── Main: 두 카드 나란히 ── */}
      <div className={styles.mainContent}>
        <div className={styles.cardsWrapper}>

          {/* Left card — Form */}
          <div className={styles.formCard}>
            <h1 className={styles.cardTitle}>Welcome back!</h1>
            <p className={styles.cardSubtitle}>Let's continue your math adventure <img src="/assets/icons/rocket.png" alt="rocket" style={{ width: 16, height: 16, objectFit: 'contain', verticalAlign: 'middle' }} /></p>
            <SignInContent />
          </div>

          {/* Right card — Marketing */}
          <div className={styles.rightCard}>
            <div className={styles.monstersImageWrapper}>
              <img
                src="/assets/login/background-monsters.png"
                alt="Solution M Characters"
                className={styles.monstersImage}
              />
            </div>
            <div className={styles.featureCardsContainer}>
              <div className={styles.featureCard}>
                <div className={styles.featureIconWrapper} style={{ background: '#FFF0E8' }}>
                  <img src="/assets/login/login-icon-1.svg" alt="" className={styles.featureIcon} />
                </div>
                <p className={styles.featureTitle}>Personalized Learning</p>
                <p className={styles.featureDesc}>Learn at your own pace</p>
              </div>
              <div className={styles.featureCard}>
                <div className={styles.featureIconWrapper} style={{ background: '#FFF8E0' }}>
                  <img src="/assets/login/login-icon-2.svg" alt="" className={styles.featureIcon} />
                </div>
                <p className={styles.featureTitle}>Earn Rewards</p>
                <p className={styles.featureDesc}>Collect badges and coins</p>
              </div>
              <div className={styles.featureCard}>
                <div className={styles.featureIconWrapper} style={{ background: '#EEF0FF' }}>
                  <img src="/assets/login/login-icon-3.svg" alt="" className={styles.featureIcon} />
                </div>
                <p className={styles.featureTitle}>Track Progress</p>
                <p className={styles.featureDesc}>See how much you improve</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Footer ── */}
      <footer className={styles.pageFooter}>
        <div className={styles.footerLinks}>
          <span>Privacy Policy</span>
          <span className={styles.footerSeparator}>|</span>
          <span>Terms of Use</span>
          <span className={styles.footerSeparator}>|</span>
          <span>Help Center</span>
        </div>
        <p className={styles.copyright}>© 2024 Solution M. All rights reserved.</p>
      </footer>

    </div>
  )
}

export default SignIn
